module.exports = __webpack_public_path__ + "static/profile-img-4569dfbaf320c96f9c5b79a454da2cdf.jpg";